import { AxiosResponse } from "axios";
import { DealernetApi } from "./DealernetApi";
import { oc } from "ts-optchain";

export const SETTINGS_CONTROLLER_PATH = "UserSettings";

export class UserSettingsService {

  public static async GetUserSettings(userId: number){    
    const response = await DealernetApi.client().request({
      method: "get",
      url: `${SETTINGS_CONTROLLER_PATH}/GetUserSettings`,
      params: {
        userId: userId
      },
    });
    
    return oc(response as AxiosResponse<any[]>).data([]);   
  }

  static async SaveUserSettings(userSettings){
    const response = await DealernetApi.client().request({
      method: "post",
      url: `${SETTINGS_CONTROLLER_PATH}/SaveUserSettings`,
      data: userSettings
    });

    return oc(response).data();
  }
}
